import styled from 'styled-components';

export const Wrapper = styled.div`
  position: relative;
`;

export const Input = styled.input`
  width: 100%;
  height: 36px;
  margin: 0;
  font-size: 15px;
  padding: 8px 16px;
  border: 1px solid ${({ theme }) => theme.colors.grey006};
  border-radius: 4px;
  outline: 0;
  box-sizing: border-box;

  ::-webkit-input-placeholder {
    /* WebKit, Blink, Edge */
    color: #9c9c9c;
  }
  :-moz-placeholder {
    /* Mozilla Firefox 4 to 18 */
    color: #9c9c9c;
  }
  ::-moz-placeholder {
    /* Mozilla Firefox 19+ */
    color: #9c9c9c;
  }
  :-ms-input-placeholder {
    /* Internet Explorer 10-11 */
    color: #9c9c9c;
  }
  ::-ms-input-placeholder {
    /* Microsoft Edge */
    color: #9c9c9c;
  }
  ::placeholder {
    /* Most modern browsers support this now. */
    color: #9c9c9c;
  }
`;

export const Envelop = styled.div`
  display: ${({ open }) => (open && 'block') || 'none'};
  position: absolute;
  width: 100%;
  height: ${({ resultsEnvelopHeight }) => resultsEnvelopHeight}px;
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 8px;
  box-shadow: 0 4px 16px 0 rgb(0, 0, 0, 10%);
  z-index: 1;
  overflow: scroll;
  -ms-overflow-style: none; /* for Internet Explorer, Edge */
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
`;
